import React, { useState } from "react";
import JsonViewerComponent from "../JsonViewer/JsonViewerComponent";
import { Button, Card } from "react-bootstrap";
import useJsonSchema from "./hooks";
import { checkForAPISuccess, showErrorToast, showSuccessToast } from "../../../Common/commonFunctions";

const EquipmentJson = (props) => {

    const [schemaEditable, setSchemaEditable] = useState(false);
    const [copyState, setCopyState] = useState(false);
    const [buttonDisabledFlag, setButtonDisabledFlag] = useState(false);

    const response = useJsonSchema();

    const onCopyToClipboardHandler = () => {
        navigator.clipboard.writeText(response.equipmentContent);
        setCopyState(true);
    }

    const onPasteFromClipboardHandler = async () => {
        let contentFromClipboard = await navigator.clipboard.readText();
        response.setEquipmentContent(contentFromClipboard);
        setCopyState(true);
    }

    const onClearButtonClickHandler = () => {
        response.setEquipmentContent("{}");
        setCopyState(false);
    }

    const onContentChangeHandler = (newContent) => {
        response.setEquipmentContent(newContent);
        setCopyState(false);
    }

    const responseHandler = (statusCode) => {
        if(checkForAPISuccess(statusCode)) {
            showSuccessToast("Schema updated successfuly");
        }
        else {
            showErrorToast("Schema update failed");
        }
    }

    const onSaveButtonClickHandler = async () => {
        setButtonDisabledFlag(true);
        const result = await response.updateEquipmentContentToRemote(responseHandler);
        if (result) {
            setButtonDisabledFlag(false);
            setCopyState(false);
            setSchemaEditable(false);
        }
    }

    const onCancelButtonClick = () => {
        response.setEquipmentContent(response.initialEquipmentJsonContent);
        setSchemaEditable(false);
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <Card>
                        <Card.Body>
                            <JsonViewerComponent
                                height={`${window.innerHeight - 200}px`}
                                content={response.equipmentContent}
                                readOnly={!schemaEditable}
                                editorWidth={12}
                                editorDisplay={true}
                                previewWidth={0}
                                previewDisplay={false}
                                minimap={false}
                                wordWrap={false}
                                theme='light'
                                loadingContent='Loading...'
                                onContentChange={onContentChangeHandler}
                                iconSize={'20px'}
                                iconGap={'8px'}
                                editiorIconGroupPosition={'end'}
                                editorHeaderIcons={
                                    [
                                        {
                                            toolTipKEy: `${copyState ? 'Copied' : 'Copy'}`,
                                            toolTipValue: `${copyState ? 'Copied' : 'Copy'}`,
                                            iconName: 'feather icon-copy',
                                            className: 'cursor-pointer',
                                            onClickHandler: () => onCopyToClipboardHandler(),
                                            display: schemaEditable
                                        },
                                        {
                                            toolTipKEy: 'Paste',
                                            toolTipValue: 'Paste',
                                            iconName: 'feather icon-clipboard',
                                            className: 'cursor-pointer',
                                            onClickHandler: () => onPasteFromClipboardHandler(),
                                            display: schemaEditable
                                        },
                                        {
                                            toolTipKEy: 'Clear',
                                            toolTipValue: 'Clear',
                                            iconName: 'feather icon-trash',
                                            color: 'red',
                                            className: 'cursor-pointer',
                                            onClickHandler: () => onClearButtonClickHandler(),
                                            display: schemaEditable
                                        }
                                    ]
                                }
                            />
                        </Card.Body>
                        <Card.Footer className="d-flex justify-content-end">
                            {
                                schemaEditable ?
                                    <>
                                        <Button
                                            disabled={buttonDisabledFlag}
                                            style={{ width: '100px' }}
                                            onClick={() => onCancelButtonClick()}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            disabled={buttonDisabledFlag}
                                            style={{ width: '100px' }}
                                            onClick={() => onSaveButtonClickHandler()}
                                        >
                                            Save
                                        </Button>
                                    </>
                                    :
                                    <Button
                                        style={{ width: '100px' }}
                                        onClick={() => setSchemaEditable(true)}
                                    >
                                        Edit
                                    </Button>
                            }
                        </Card.Footer>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default EquipmentJson;